var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SpreadSheet',{attrs:{"type":"products","downloadLink":_vm.downloadlink,"uploadLink":_vm.uploadLink},on:{"reLoadData":_vm.reLoadData}}),_c('Products',{ref:"products",attrs:{"isOPS":true,"level":"Corporate"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }